(() => {
  console.log('!@$!@$!@$!@');
  
  window.cartDrawerAccessoriesDragController?.abort();
  const controller = new AbortController();
  const { signal } = controller;
  window.cartDrawerAccessoriesDragController = controller;
  delete window.cartDrawerAccessoriesDragInitialized;

  const railSelector = '.cart-drawer-accessories__rail';
  const dragThreshold = 5;
  let drag = null;
  let suppressClickOn = null;

  document.addEventListener('mousedown', (event) => {
    if (event.button !== 0) return;

    const rail = event.target.closest(railSelector);
    if (!rail || rail.scrollWidth <= rail.clientWidth) return;

    suppressClickOn = null;
    drag = {
      rail,
      startX: event.clientX,
      startScrollLeft: rail.scrollLeft,
      moved: false
    };
  }, { signal });

  document.addEventListener('mousemove', (event) => {
    if (!drag) return;

    if ((event.buttons & 1) === 0) {
      finishDrag();
      return;
    }

    const distance = event.clientX - drag.startX;
    if (!drag.moved && Math.abs(distance) < dragThreshold) return;

    drag.moved = true;
    drag.rail.classList.add('is-dragging');
    drag.rail.scrollLeft = drag.startScrollLeft - distance;
    event.preventDefault();
  }, { passive: false, signal });

  const finishDrag = (event) => {
    if (!drag) return;

    const { rail, moved } = drag;
    drag = null;

    rail.classList.remove('is-dragging');
    if (moved && event?.type === 'mouseup') {
      suppressClickOn = rail;
      window.setTimeout(() => {
        if (suppressClickOn === rail) suppressClickOn = null;
      }, 250);
    }
  };

  document.addEventListener('mouseup', finishDrag, { signal });
  window.addEventListener('blur', finishDrag, { signal });

  document.addEventListener('click', (event) => {
    if (!suppressClickOn) return;

    const rail = suppressClickOn;
    suppressClickOn = null;

    if (rail.contains(event.target)) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, { capture: true, signal });

  document.addEventListener('dragstart', (event) => {
    if (event.target.closest(railSelector)) event.preventDefault();
  }, { signal });
})();
